<template>
    <div>
        <div class="aml">
            <el-row>
                <el-collapse v-model="activeName" accordion style="margin-bottom: 20px" v-if="$store.state.registration.form10.share_data.length && $store.state.registration.form10.tags.length">
                    <el-collapse-item title="共享数据" name="1" style="color: yellow !important;">
                        <el-table
                                :data="$store.state.registration.form10.share_data"
                                stripe
                                style="width: 100%">
                            <el-table-column
                                    prop="sfTime"
                                    label="整合末次随访时间"
                                    width="">
                            </el-table-column>
                            <el-table-column
                                    prop="status"
                                    label="生存状态"
                                    width="">
                            </el-table-column>
                            <el-table-column
                                    prop="yzType"
                                    label="移植类型"
                                    width="">
                            </el-table-column>
                            <el-table-column
                                    prop="yzTime"
                                    label="移植时间"
                                    width="">

                            </el-table-column>
                            <el-table-column
                                    prop="hjTime"
                                    label="缓解时间">
                            </el-table-column>
                            <el-table-column
                                    prop="ffTime"
                                    label="复发时间">
                            </el-table-column>
                            <el-table-column
                                    prop="swTime"
                                    label="死亡时间">
                            </el-table-column>
                        </el-table>
                    </el-collapse-item>
                </el-collapse>
                <el-col :span="24" style="padding-bottom: 10px;font-size: 15px;">
                    <el-col :span="12">
                        <div class="clearfix">
                            <span>治疗随访记录</span>
                            <el-button icon="el-icon-arrow-right" v-if="!all" type="text"
                                       style="float: right;margin-right: 20px;font-size: 14px"
                                       @click="handelAll(true)">
                                全部展开
                            </el-button>
                            <el-button icon="el-icon-arrow-down" v-else type="text"
                                       style="float: right;margin-right: 20px;font-size: 14px"
                                       @click="handelAll(false)">取消展开
                            </el-button>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="clearfix">
                            <span>治疗及随访事件</span>
                        </div>
                    </el-col>
                </el-col>
                <el-col :span="12" style="padding-right:20px;">
                    <md-steppers style="border:1px solid #eee;" :md-active-step.sync="active" md-vertical>
                        <md-step :id="'kms'+(index+1).toString()" :md-label="handelShow(item.label,item.tag)"
                                 @click="handelSetcorle(item)"
                                 v-for="(item,index) in form6.timeline" :key="index"
                                 :class="[all?'all':'' , $store.state.registration.form9.indexOf('form6_' + (index+1).toString()) >= 0?'container':'',
                                 item.tag == 1?'tag':'' , item.tag ==2?'tag-2':'',item.tag == 3?'tag-3':'']"
                                 v-if="item.falg==0 || is_admin == 'tru1e'">
                            <el-row :style="item.falg == 1?'border:1px solid #eee;background-color: #f5f7fa;':'border:1px solid #eee;'">
                                <el-col :span="24">
                                    <el-form-item label="时间">
                                        <span v-if="item.time">{{ item.time.split("#")[0] }}&nbsp;&nbsp;&nbsp;</span><span>{{ item.hospital }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" v-if="item.type">
                                    <el-form-item label="诊断分型">
                                        <span>{{ item.type }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" v-if="item.programme.length!=0">
                                    <el-form-item label="治疗方案">
                                        <el-col :span="24" v-for="(items,index) in item.programme" :key="index"
                                                class="zhiliao-event">
                                            <el-col :span='12'>
                                                <span>{{ items.label }}</span>
                                            </el-col>
                                            <el-col :span="12" v-for="(itemss,index) in items.item" :key="index">
                                                <el-form-item :label="itemss.label" label-width="60px"
                                                              style="margin-bottom: 0px;" v-if="items.value=='one'">
                                                    <span>{{ itemss.value }}(mg/m 2)</span>
                                                </el-form-item>
                                                <div v-else-if="items.value == 'five' && itemss"
                                                     style="margin-left: 10px;">
                                                    <span v-if="parseInt(itemss)"> &nbsp;{{ itemss }}(mg/m 2)</span>
                                                    <span v-else> {{ itemss }}</span>
                                                </div>
                                                <div v-else>
                                                    <span v-if="itemss"
                                                          style="margin-left: 10px;"> &nbsp;{{ itemss }}</span>
                                                </div>
                                            </el-col>
                                        </el-col>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" v-if="item.labelq">
                                    <el-form-item :label="item.labelq">
                                        <span>{{ item.valueq }}</span>
                                    </el-form-item>
                                    <el-form-item label="其它" v-if="item.other">
                                        <span>{{ item.other }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" v-if="item.jiuzhennianling">
                                    <el-form-item label="就诊年龄">
                                        <span>{{ item.jiuzhennianling }}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="备注">
                                        <el-input type="textarea" style="width:80%" :rows="4"
                                                  v-model="item.remarks"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div style="text-align: right">
                                <div v-if="!item.not_del">
                                    <el-button type="info" plain @click="handelremove(index)">移除</el-button>
                                </div>
                                <div v-else>
                                    <div v-if="item.tag > 0">
                                        <el-button type="info" plain @click="handelCaiNa(index,2)">不采纳
                                        </el-button>
                                        <el-button  type="success" plain @click="handelCaiNa(index,3)">
                                            采纳
                                        </el-button>
                                    </div>
                                    <div v-else>
                                        <el-button v-if="item.falg==0" type="danger" plain @click="handelObsolete(index,1)">作废
                                        </el-button>
                                        <el-button v-if="item.falg==1" type="danger" plain @click="handelObsolete(index,0)">
                                            取消作废
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </md-step>
                    </md-steppers>
                </el-col>
                <el-col :span="12" style="border:1px solid #eee;padding:20px 20px 0 20px;">
                    <el-col>
                        <div class="heard-label">
                            <span>诱导治疗</span>
                        </div>
                        <el-row class="heard" style="padding-top:10px;padding-right:10px;margin:0px">
                            <el-col :span="2" style="margin-top:130px;">
                                <el-button
                                        @click="filter('治疗',form6.fangan_shijian)"
                                        type="text"
                                        style="font-size:20px;padding:0px 0px;line-height: 30px">
                                    <i class="el-icon-d-arrow-left"></i>
                                    <i class="el-icon-circle-plus-outline"></i>
                                </el-button>
                            </el-col>
                            <el-col :span="22" style="border:1px solid #eee;padding-left:20px;margin-bottom: 0px;"
                                    :class="setting=='治疗'?'is_acivt':'' || setting=='初治'?'is_acivt':''">
                                <el-form label-position="left" label-width="100px" v-if="bingli">
                                    <el-form-item label="治疗方案" label-width="80px">
                                        <el-input placeholder="治疗方案" type="textarea" :rows="4"
                                                  v-model="form6.newzhiliaofangan"></el-input>
                                    </el-form-item>
                                </el-form>
                                <el-row v-if="showAML && !bingli && !showM3" style="margin-bottom: 5px">
                                    <el-col :span="6" style="line-height: 25px">
                                        <el-checkbox v-model="form6.zhiliaofangan.one" true-label="标准治疗方案">标准治疗方案
                                        </el-checkbox>
                                    </el-col>
                                    <el-col :span="12" style="margin-bottom: 10px">
                                        <el-select
                                                placeholder="标准治疗方案"
                                                :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                v-model="form6.biaozhunzhiliaofangan"
                                        >
                                            <el-option label="DA" value="DA"></el-option>
                                            <el-option label="IA" value="IA"></el-option>
                                            <el-option label="HAA" value="HAA"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-tooltip
                                                class="item"
                                                v-if="form6.biaozhunzhiliaofangan=='DA' && form6.zhiliaofangan.one=='标准治疗方案'"
                                                content="柔红霉素"
                                                placement="top"
                                        >
                                            <el-form-item label="DNR" prop="dnr" label-width="50px">
                                                <el-input placeholder :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                          v-model="form6.dnr">
                                                    <span slot="append">
                                                        mg/m
                                                        <sup>2</sup>
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                        <el-tooltip
                                                class="item"
                                                v-if="form6.biaozhunzhiliaofangan=='IA' && form6.zhiliaofangan.one=='标准治疗方案'"
                                                content="去甲氧柔红霉素"
                                                placement="top"
                                        >
                                            <el-form-item label="IDA" prop="ida" label-width="50px">
                                                <el-input placeholder :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                          v-model="form6.ida">
                                                    <span slot="append">
                                                        mg/m
                                                        <sup>2</sup>
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                        <el-tooltip
                                                class="item"
                                                v-if="form6.biaozhunzhiliaofangan=='HAA' && form6.zhiliaofangan.one=='标准治疗方案'"
                                                content="高三尖杉酯碱"
                                                placement="top"
                                        >
                                            <el-form-item label="HHT" prop="hht" label-width="50px">
                                                <el-input placeholder :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                          v-model="form6.hht">
                                                    <span slot="append">
                                                        mg/m
                                                        <sup>2</sup>
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-tooltip
                                                class="item"
                                                v-if="form6.biaozhunzhiliaofangan=='DA' && form6.zhiliaofangan.one=='标准治疗方案'"
                                                content="阿糖胞苷"
                                                placement="top"
                                        >
                                            <el-form-item label="Ara-C" prop="dnr_ara_c" label-width="60px">
                                                <el-input
                                                        placeholder
                                                        :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                        v-model="form6.dnr_ara_c"
                                                >
                                                    <span slot="append">
                                                        mg/m
                                                        <sup>2</sup>
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                        <el-tooltip
                                                class="item"
                                                v-if="form6.biaozhunzhiliaofangan=='IA' && form6.zhiliaofangan.one=='标准治疗方案'"
                                                content="阿糖胞苷"
                                                placement="top"
                                        >
                                            <el-form-item label="Ara-C" prop="ida_ara_c" label-width="60px">
                                                <el-input
                                                        placeholder
                                                        :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                        v-model="form6.ida_ara_c"
                                                >
                                                    <span slot="append">
                                                          mg/m
                                                        <sup>2</sup>
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                        <el-tooltip
                                                class="item"
                                                v-if="form6.biaozhunzhiliaofangan=='HAA' && form6.zhiliaofangan.one=='标准治疗方案'"
                                                content="阿糖胞苷"
                                                placement="top"
                                        >
                                            <el-form-item label="Ara-C" prop="hht_ara_c" label-width="60px">
                                                <el-input
                                                        placeholder
                                                        :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                        v-model="form6.hht_ara_c"
                                                >
                                                    <span slot="append">
                                                        mg/m
                                                        <sup>2</sup>
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-tooltip
                                                class="item"
                                                v-if="form6.biaozhunzhiliaofangan=='HAA' &&form6.zhiliaofangan.one=='标准治疗方案'"
                                                content="阿柔比星"
                                                placement="top"
                                        >
                                            <el-form-item label="Acla" prop="acla" label-width="50px">
                                                <el-input placeholder :disabled="form6.zhiliaofangan.one!='标准治疗方案'"
                                                          v-model="form6.acla">
                                                    <span slot="append">
                                                        mg/m
                                                        <sup>2</sup>
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                    </el-col>
                                </el-row>
                                <el-row v-if="showAML && !bingli && !showM3"
                                        style="display: flex;align-items: center;margin-top: 0px">
                                    <el-col :span="6">
                                        <el-checkbox v-model="form6.zhiliaofangan.eight" true-label="维奈克拉联合">维奈克拉联合
                                        </el-checkbox>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-select
                                                :disabled="form6.zhiliaofangan.eight!='维奈克拉联合'"
                                                placeholder="请选择"
                                                style="width: 100%"
                                                v-model="form6.weinaikelafangan"
                                        >
                                            <el-option label="阿扎胞苷" value="阿扎胞苷"></el-option>
                                            <el-option label="阿糖胞苷" value="阿糖胞苷"></el-option>
                                            <el-option label="地西他滨" value="地西他滨"></el-option>
                                            <el-option label="其它" value="其它"></el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col :span="7" v-show="form6.weinaikelafangan=='其它'"
                                            style="margin-left: 5px">
                                        <el-input placeholder="请输入内容"
                                                  v-model="form6.weinaikelaqita">
                                        </el-input>
                                    </el-col>
                                </el-row>
                                <el-row v-if="!bingli && showM3">
                                    <el-col :span="6">
                                        <el-checkbox v-model="form6.zhiliaofangan.seven" true-label="APL的治疗方案">
                                            APL的治疗方案
                                        </el-checkbox>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-radio-group v-model="form6.aml_m3"
                                                        :disabled="form6.zhiliaofangan.seven!='APL的治疗方案'"
                                                        v-if="form6.zhiliaofangan.seven=='APL的治疗方案'">
                                            <el-radio label="ATRA+砷剂">ATRA+砷剂</el-radio>
                                            <el-radio label="ATRA+砷剂+化疗">ATRA+砷剂+化疗</el-radio>
                                        </el-radio-group>
                                    </el-col>
                                    <el-col :span="6">
                                        <el-checkbox v-model="form6.zhiliaofangan.three" true-label="姑息治疗">姑息治疗
                                        </el-checkbox>
                                    </el-col>
                                </el-row>
                                <el-row v-if="showAML && !bingli && !showM3">
                                    <el-col :span="6">
                                        <el-checkbox v-model="form6.zhiliaofangan.tow" true-label="去甲基化治疗">去甲基化治疗
                                        </el-checkbox>
                                        <!-- <el-checkbox v-model="form6.zhiliaofangan.three" true-label="姑息治疗">姑息治疗</el-checkbox> -->
                                    </el-col>
                                    <el-col :span="6">
                                        <el-checkbox v-model="form6.zhiliaofangan.three" true-label="姑息治疗">姑息治疗
                                        </el-checkbox>
                                    </el-col>
                                </el-row>
                                <el-row v-if="showALL && !bingli && !showM3"
                                        style="line-height: 25px;margin-bottom: 0px">
                                    <el-col :span="8">
                                        <el-checkbox v-model="form6.zhiliaofangan.four" true-label="以VDCP为基础的方案">
                                            以VDCP为基础的方案
                                        </el-checkbox>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-tooltip class="item" content="酪氨酸激酶抑制剂" placement="top">
                                            <el-form-item label="TKI药品" prop="yimatini"
                                                          style="width: 100%;margin-bottom: 8px">
                                                <span slot="label">
                                                  <el-checkbox v-model="form6.zhiliaofangan.five"
                                                               true-label="TKI">TKI</el-checkbox>
                                                </span>
                                                <el-input
                                                        placeholder
                                                        :disabled="form6.zhiliaofangan.five!='TKI'"
                                                        class="input-with-select"
                                                        v-model="form6.tki_yaowu_yongliang"
                                                >
                                                    <el-select
                                                            v-model="form6.tki_yaowu"
                                                            :disabled="form6.zhiliaofangan.five!='TKI'"
                                                            style="width:80px;"
                                                            slot="prepend"
                                                            placeholder="请选择"
                                                    >
                                                        <el-option label="伊马替尼" value="伊马替尼"></el-option>
                                                        <el-option label="达沙替尼" value="达沙替尼"></el-option>
                                                        <el-option label="其他TKI" value="其他TKI"></el-option>
                                                    </el-select>
                                                    <span slot="append">
                                                        mg
                                                    </span>
                                                </el-input>
                                            </el-form-item>
                                        </el-tooltip>
                                    </el-col>
                                </el-row>
                                <el-row v-if='!bingli' style="margin: 0;">
                                    <el-row style="margin: 10px 0px;">
                                        <el-col :span="24">
                                            <el-checkbox v-model="form6.zhiliaofangan.six" true-label="新药临床试验">
                                                新药临床试验
                                                <el-tooltip class="item" :content="form6.xinyaolinchuangshiyan"
                                                            placement="top">
                                                    <el-input
                                                            v-model="form6.xinyaolinchuangshiyan"
                                                            :disabled="form6.zhiliaofangan.six!='新药临床试验'"
                                                            placeholder="请输入内容"
                                                    ></el-input>
                                                </el-tooltip>
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="24">
                                            <el-checkbox v-model="form6.zhiliaofangan.other" true-label="其他">
                                                其他
                                                <el-input
                                                        v-model="form6.qita"
                                                        :disabled="form6.zhiliaofangan.other!='其他'"
                                                        placeholder="请输入内容"
                                                ></el-input>
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-row>
                                <el-row style="margin: 0">
                                    <el-col :span="24">
                                        <el-form-item label="时间" label-width="42px">
                                            <el-date-picker
                                                    v-model="form6.fangan_shijian"
                                                    class="input"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="选择时间"
                                                    style="width:47%"
                                            ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="24" style="padding-top:10px ">
                                <el-row style="margin:0px" :class="setting=='放弃'?'is_acivt':''">
                                    <el-col :span="2">
                                        <el-button
                                                @click="filter('放弃',form6.fangqi_shijian,'类型',form6.fangqi_shijian_type)"
                                                type="text"
                                                style="font-size:20px;padding:0px 0px;line-height: 30px">
                                            <i class="el-icon-d-arrow-left"></i>
                                            <i class="el-icon-circle-plus-outline"></i>
                                        </el-button>
                                    </el-col>
                                    <el-col :span="4" style="line-height: 30px;">放弃</el-col>
                                    <el-col :span="9">
                                        <el-form-item label="时间" label-width="80px" prop="auto_sct_shijian">
                                            <el-date-picker
                                                    v-model="form6.fangqi_shijian"
                                                    class="input"
                                                    value-format="yyyy-MM-dd"
                                                    type="date"
                                                    placeholder="选择时间"
                                            ></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="9">
                                        <el-form-item label="类型" label-width="60px">
                                            <el-select
                                                    clearable
                                                    style="width: 100%;"
                                                    :disabled="form6.fangqi_shijian?false:true"
                                                    v-model="form6.fangqi_shijian_type"
                                            >
                                                <el-option label="转院治疗" value="转院治疗"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="24" style="padding-top: 5px;" class="sui">
                        <el-col :span="24">
                            <el-col>
                                <div class="heard-label">
                                    <span>移植治疗</span>
                                </div>
                                <el-row class="heard">
                                    <el-col :span="24" :class="setting=='移植-Auto-SCT'?'is_acivt':''">
                                        <el-row style="margin-bottom:10px">
                                            <el-col :span="2">
                                                <el-button
                                                        @click="filter('移植-Auto-SCT',form6.auto_sct_shijian)"
                                                        type="text"
                                                        style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                    <i class="el-icon-d-arrow-left"></i>
                                                    <i class="el-icon-circle-plus-outline"></i>
                                                </el-button>
                                            </el-col>
                                            <el-col :span="4" style="line-height: 30px;">Auto-SCT</el-col>
                                            <el-col :span="8">
                                                <el-form-item label="时间" label-width="80px" prop="auto_sct_shijian">
                                                    <el-date-picker
                                                            v-model="form6.auto_sct_shijian"
                                                            class="input"
                                                            value-format="yyyy-MM-dd"
                                                            type="date"
                                                            placeholder="选择时间"
                                                    ></el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                    <el-col :span="24" :class="setting=='移植-Allo-SCT'?'is_acivt':''">
                                        <el-row style="margin:0px">
                                            <el-col :span="2">
                                                <el-button
                                                        @click="filter('移植-Allo-SCT',form6.allo_sct_shijian,'类型',form6.allo_sct_leixing)"
                                                        type="text"
                                                        style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                    <i class="el-icon-d-arrow-left"></i>
                                                    <i class="el-icon-circle-plus-outline"></i>
                                                </el-button>
                                            </el-col>
                                            <el-col :span="4" style="line-height: 30px;">Allo-SCT</el-col>
                                            <el-col :span="9">
                                                <el-form-item label="时间" label-width="80px" prop="allo_sct_shijian">
                                                    <el-date-picker
                                                            v-model="form6.allo_sct_shijian"
                                                            class="input"
                                                            value-format="yyyy-MM-dd"
                                                            type="date"
                                                            placeholder="选择时间"
                                                    ></el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="9">
                                                <el-form-item label="类型" label-width="60px" prop="allo_sct_shijian">
                                                    <el-select
                                                            placeholder="类型"
                                                            clearable
                                                            style="width: 100%;"
                                                            :disabled="form6.allo_sct_shijian?false:true"
                                                            v-model="form6.allo_sct_leixing"
                                                    >
                                                        <el-option label="脐血" value="脐血"></el-option>
                                                        <el-option label="非血缘" value="非血缘"></el-option>
                                                        <el-option label="同胞全相合" value="同胞全相合"></el-option>
                                                        <el-option label="单倍体" value="单倍体"></el-option>
                                                        <el-option label="不祥" value="不祥"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-col>
                        <el-col>
                            <div class="heard-label">
                                <span>疾病状态</span>
                            </div>
                            <el-row class="heard">
                                <el-col :span="24" :class="setting=='缓解'?'is_acivt':''">
                                    <el-row style="margin-bottom:10px">
                                        <el-col :span="2">
                                            <el-button
                                                    @click="filter('缓解',form6.huode_cr_shijian,'MRD',form6.allo_sct_mrd)"
                                                    type="text"
                                                    style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                <i class="el-icon-d-arrow-left"></i>
                                                <i class="el-icon-circle-plus-outline"></i>
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4" style="line-height: 26px;">完全缓解(CR)</el-col>
                                        <el-col :span="9">
                                            <el-form-item label="时间" label-width="80px" prop="huode_cr_shijian">
                                                <el-date-picker
                                                        v-model="form6.huode_cr_shijian"
                                                        class="input"
                                                        value-format="yyyy-MM-dd"
                                                        type="date"
                                                        placeholder="选择时间"
                                                ></el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="9">
                                            <el-form-item label="MRD" label-width="60px" prop="allo_sct_mrd">
                                                <el-input placeholder style="width:100%"
                                                          v-model="form6.allo_sct_mrd"
                                                          :disabled="form6.huode_cr_shijian?false:true">
                                                    <span slot="append">%</span>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="24" :class="setting=='未缓解'?'is_acivt':''">
                                    <el-row style="margin:0px">
                                        <el-col :span="2">
                                            <el-button
                                                    @click="filter('未缓解',form6.huode_nr_shijian)"
                                                    type="text"
                                                    style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                <i class="el-icon-d-arrow-left"></i>
                                                <i class="el-icon-circle-plus-outline"></i>
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4" style="line-height: 26px;">未缓解(NR)</el-col>
                                        <el-col :span="9">
                                            <el-form-item label="时间" label-width="80px" prop="huode_cr_shijian">
                                                <el-date-picker
                                                        v-model="form6.huode_nr_shijian"
                                                        class="input"
                                                        value-format="yyyy-MM-dd"
                                                        type="date"
                                                        placeholder="选择时间"
                                                ></el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="24" :class="setting=='复发'?'is_acivt':''">
                                    <el-row style="margin-bottom:10px">
                                        <el-col :span="2">
                                            <el-button
                                                    @click="filter('复发',form6.shoucifufashijian,form6.zhenduanfenxing)"
                                                    type="text"
                                                    style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                <i class="el-icon-d-arrow-left"></i>
                                                <i class="el-icon-circle-plus-outline"></i>
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4" style="line-height: 30px;">复发</el-col>
                                        <el-col :span="9">
                                            <el-form-item label="时间" label-width="80px" prop="shoucifufashijian"
                                                          style="margin-bottom: 13px;">
                                                <el-date-picker
                                                        v-model="form6.shoucifufashijian"
                                                        class="input"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择时间"
                                                ></el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="9">
                                            <el-form-item label="分型" label-width="60px">
                                                <el-cascader
                                                        :disabled="form6.shoucifufashijian?false:true"
                                                        @focus="Fenfocus"
                                                        :options="zhenduanfenxing"
                                                        v-model="form6.zhenduanfenxing"
                                                        style="width: 100%"
                                                ></el-cascader>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="24" :class="setting=='死亡'?'is_acivt':''">
                                    <el-row style="margin:0px">
                                        <el-col :span="2">
                                            <el-button
                                                    @click="filter('死亡',form6.shifou_siwang,'死亡原因',form6.siwangyuanyin)"
                                                    type="text"
                                                    style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                <i class="el-icon-d-arrow-left"></i>
                                                <i class="el-icon-circle-plus-outline"></i>
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4" style="line-height: 30px;">死亡</el-col>
                                        <el-col :span="9">
                                            <el-form-item label="时间" label-width="80px" prop="shoucifufashijian">
                                                <el-date-picker
                                                        v-model="form6.shifou_siwang"
                                                        class="input"
                                                        type="date"
                                                        :value-format="form6.siwangshijian_accurate=='1'?'yyyy-MM-dd':'yyyy-MM'"
                                                        :format="form6.siwangshijian_accurate=='1'?'yyyy-MM-dd':'yyyy-MM'"
                                                        placeholder="选择时间"
                                                ></el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="单位" label-width="60px" prop="allo_sct_shijian">
                                                <el-radio-group v-model="form6.siwangshijian_accurate">
                                                    <el-radio label="1">天</el-radio>
                                                    <el-radio label="2">月</el-radio>
                                                </el-radio-group>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="24">
                                            <el-form-item label="死亡原因" label-width="80px"
                                                          prop="form6.siwangyuanyin">
                                                <el-checkbox-group v-model="form6.siwangyuanyin"
                                                                   :disabled="form6.shifou_siwang?false:true">
                                                    <el-checkbox label="重要脏器出血"></el-checkbox>
                                                    <el-checkbox label="感染"></el-checkbox>
                                                    <el-checkbox label="白血病浸润"></el-checkbox>
                                                    <el-checkbox label="非白血病相关死亡"></el-checkbox>
                                                    <el-checkbox label="移植相关死亡"></el-checkbox>
                                                    <el-checkbox label="心脑血管意外"></el-checkbox>
                                                    <el-checkbox label="其他">
                                                        其他
                                                        <el-input
                                                                v-model="form6.siwangyuanyin_qita"
                                                                :disabled="form6.siwangyuanyin.toString().indexOf('其他') < 0"
                                                                placeholder="请输入内容"
                                                        ></el-input>
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col>
                            <div class="heard-label">
                                <span>随访状态</span>
                            </div>
                            <el-row class="heard">
                                <el-col :span="24" :class="setting=='失访'?'is_acivt':''">
                                    <el-tooltip class="item" content="末次能随访到事件的发生时间" placement="top" :tabindex='-1'>
                                        <el-row style="margin-bottom:10px">
                                            <el-col :span="2">
                                                <el-button
                                                        @click="filter('失访',form6.shifang_shijian)"
                                                        type="text"
                                                        style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                    <i class="el-icon-d-arrow-left"></i>
                                                    <i class="el-icon-circle-plus-outline"></i>
                                                </el-button>
                                            </el-col>
                                            <el-col :span="4" style="line-height: 30px;">失访</el-col>
                                            <el-col :span="8">
                                                <el-form-item label="时间" label-width="80px" prop="auto_sct_shijian">
                                                    <el-date-picker
                                                            v-model="form6.shifang_shijian"
                                                            class="input"
                                                            value-format="yyyy-MM-dd"
                                                            type="date"
                                                            placeholder="选择时间"
                                                    ></el-date-picker>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-tooltip>
                                </el-col>
                                <el-col :span="24">
                                    <el-row style="margin:0px" :class="setting=='随访'?'is_acivt':''">
                                        <el-col :span="2">
                                            <el-button
                                                    @click="filter('随访',form6.suifang_shijian,'备注',form6.suifang_beiju)"
                                                    type="text"
                                                    style="font-size:20px;padding:0px 0px;line-height: 30px">
                                                <i class="el-icon-d-arrow-left"></i>
                                                <i class="el-icon-circle-plus-outline"></i>
                                            </el-button>
                                        </el-col>
                                        <el-col :span="4" style="line-height: 30px;">随访</el-col>
                                        <el-col :span="9">
                                            <el-form-item label="时间" label-width="80px" prop="auto_sct_shijian">
                                                <el-date-picker
                                                        v-model="form6.suifang_shijian"
                                                        class="input"
                                                        value-format="yyyy-MM-dd"
                                                        type="date"
                                                        placeholder="选择时间"
                                                ></el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="9">
                                            <el-form-item label="备注" label-width="60px" prop="suifang_beiju">
                                                <el-input placeholder style="width:100%"
                                                          v-model="form6.suifang_beiju">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-col>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    // import jiancha from "./widgets/shifou";
    import zhenduanfenxing from "../../../config/zhenduanfenxing";
    import 'vue-material/dist/vue-material.min.css'
    import 'vue-material/dist/theme/default.css'

    export default {
        props: ["bingli"],

        data() {
            return {
                is_admin: localStorage.getItem('is_admin'),
                active: 'kms1',
                form6: this.$store.state.registration.form6,
                num: this.$store.state.registration.form6.timeline.length,
                rules: {},
                zhenduanfenxing: zhenduanfenxing,
                // timeline: this.$store.state.registration.form6.timeline,
                all: false,
                setting: '',
                one: {
                    IA: [
                        {
                            label: 'IDA',
                            id: 'ida',
                            value: '',
                        },
                        {
                            label: 'Ara-C',
                            id: 'ida_ara_c',
                            value: '',
                        }
                    ],
                    DA: [
                        {
                            label: 'DNR',
                            id: 'dnr',
                            value: '',
                        },
                        {
                            label: 'Ara-C',
                            id: 'dnr_ara_c',
                            value: '',
                        }
                    ],
                    HAA: [
                        {
                            label: 'HHT',
                            id: 'hht',
                            value: '',
                        },
                        {
                            label: 'Ara-C',
                            id: 'hht_ara_c',
                            value: '',
                        },
                        {
                            label: 'Acla',
                            id: 'acla',
                            value: '',
                        }
                    ]
                },
                activeName: "1"
            };
        },
        computed: {
            showSuif() {
                return true
            },
            showAML() {
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[0] ===
                    "急性双表型白血病"
                )
                    return true;
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === "不详")
                    return true;
                return this.$store.state.registration.form2.zhenduanfenxing[0] === "AML";
            },
            showM3() {
                let m3 = this.$store.state.registration.form2.zhenduanfenxing
                if (m3.length == 2 && m3[1] === "急性早幼粒细胞白血病（M3）") {
                    return true;
                }
                return false
            },
            showALL() {
                if (
                    this.$store.state.registration.form2.zhenduanfenxing[0] ===
                    "急性双表型白血病"
                )
                    return true;
                if (this.$store.state.registration.form2.zhenduanfenxing[0] === "不详")
                    return true;
                return this.$store.state.registration.form2.zhenduanfenxing[0] === "ALL";
            }
        },
        methods: {
            handelShow(label, tag){
                if(tag == 2){
                    return label + " (未采纳)"
                }
                if(tag == 3){
                    if(label.indexOf('移植') > -1) {
                        return label + " (移植信息已整合)"
                    } else if(label.indexOf('随访') > -1){
                        return label + ` (末次随访时间已整合)`
                    }else return label + ` (${label}信息已整合)`
                }
                return label
            },
            handelSetcorle(item) {
                this.setting = item.label
                console.log(item)
            },
            handelAll(v) {
                this.all = v
            },
            Fenfocus(env) {
                console.log(env)
            },
            handelCaiNa(index, value) {
                this.active = 'kms1'
                var temp = []
                for (var i = 0; i < this.form6.timeline.length; i++) {
                    if (i == index) {
                        this.form6.timeline[i].tag = value
                    }
                    temp.push(this.form6.timeline[i])
                }
                this.form6.timeline = temp
            },
            handelObsolete(index, value) {
                this.active = 'kms1'
                var temp = []
                for (var i = 0; i < this.form6.timeline.length; i++) {
                    if (i == index) {
                        this.form6.timeline[i].falg = value
                        if(this.form6.timeline[i].tag && this.form6.timeline[i].tag == 1) {
                            this.form6.timeline[i].tag = 2
                        }
                    }
                    temp.push(this.form6.timeline[i])
                }
                this.form6.timeline = temp
            },
            handelremove(index) {
                this.active = 'kms1'
                var temp = []
                var status = 0;
                var that = this
                for (var i = 0; i < this.form6.timeline.length; i++) {
                    if (i != index) {
                        temp.push(this.form6.timeline[i])
                        var value = this.form6.timeline[i].label
                        if (that.form6.timeline[i].falg == 0) {
                            if (value == '死亡' || value == '失访' || value == '放弃') {
                                this.$store.state.registration.form7.shengcunzhuangtai = value
                            } else {
                                this.$store.state.registration.form7.shengcunzhuangtai = '存活'
                            }
                            if (value == '死亡') {
                                status = 1
                            }
                        }
                    }
                }
                if (status == 1) {
                    this.$store.state.registration.form7.shengcunzhuangtai = '死亡'
                } else {
                    this.$store.state.registration.form7.shengcunzhuangtai = '存活'
                }
                this.form6.timeline = temp
            },
            addRow(value, time, label, valuee) {
                var programme = []
                var type = ''
                var labelq = ''
                var valueq = ''
                var other = ''
                if (value == '治疗') {
                    if (this.bingli == '1') {
                        programme.push({
                            label: this.form6.newzhiliaofangan,
                            value: '',
                            item: '',
                        })
                    } else {
                        for (var key in this.form6.zhiliaofangan) {
                            if (this.form6.zhiliaofangan[key]) {
                                if (key == 'one') {
                                    var temp = this.one[this.form6.biaozhunzhiliaofangan]
                                    if (temp) {
                                        for (var i = 0; i < temp.length; i++) {
                                            temp[i].value = this.form6[temp[i]['id']]
                                        }
                                        programme.push({
                                            label: this.form6.zhiliaofangan[key] + '  ' + this.form6.biaozhunzhiliaofangan,
                                            value: 'one',
                                            item: temp,
                                        })
                                    }
                                } else if (key == 'five') {
                                    programme.push({
                                        label: this.form6.zhiliaofangan[key],
                                        value: 'five',
                                        item: [this.form6.tki_yaowu_yongliang, this.form6.tki_yaowu],
                                    })
                                } else if (key == 'six') {
                                    programme.push({
                                        label: this.form6.zhiliaofangan[key],
                                        value: 'six',
                                        item: [this.form6.xinyaolinchuangshiyan],
                                    })
                                } else if (key == 'seven') {
                                    programme.push({
                                        label: this.form6.zhiliaofangan[key],
                                        value: 'seven',
                                        item: [this.form6.aml_m3],
                                    })
                                } else if (key == 'eight') {
                                    programme.push({
                                        label: this.form6.zhiliaofangan[key],
                                        value: 'eight',
                                        item: [this.form6.weinaikelafangan, this.form6.weinaikelaqita],
                                    })
                                } else if (key == 'other') {
                                    programme.push({
                                        label: this.form6.zhiliaofangan[key],
                                        value: 'other',
                                        item: [this.form6.qita],
                                    })
                                } else {
                                    programme.push({
                                        label: this.form6.zhiliaofangan[key],
                                        value: '',
                                        item: '',
                                    })
                                }
                            }
                        }
                    }
                    type = this.$store.state.registration.form2.zhenduanfenxing
                    if (type.length == 1) {
                        type = type[0]
                    } else {
                        type = type[1]
                    }
                } else {
                    if (value == '死亡' || value == '失访' || value == '放弃') {

                        if (this.$store.state.registration.form7.shengcunzhuangtai != '死亡') {
                            this.$store.state.registration.form7.shengcunzhuangtai = value
                        }
                    } else {
                        this.$store.state.registration.form7.shengcunzhuangtai = '存活'
                    }
                    if (value == '复发') {
                        this.form6.shifou_fufa = '是'
                        if (label.length == 1) {
                            type = label[0]
                        } else {
                            type = label[1]
                        }
                        label = ''
                    } else if (value == '死亡') {
                        if (valuee.length) {
                            if (valuee.indexOf('其他') > -1) {
                                other = this.form6.siwangyuanyin_qita
                            }
                            valuee = valuee.join("；")
                        } else {
                            valuee = ''
                        }
                    } else if (value == '缓解') {
                        this.form6.shifou_huodecr = '是'
                    }
                    labelq = label
                    valueq = valuee
                }
                // if (this.timeline.length == 1) {
                //     value = '初治'
                // }
                if (time) {
                    time = time + '#' + this.form6.timeline.length
                }
                this.form6.timeline.push(
                    {
                        other: other,
                        type: type,
                        jiuzhennianling: '',
                        labelq: labelq,
                        valueq: valueq,
                        time: time,
                        falg: 0,
                        programme: programme,
                        label: value,
                        hospital: this.$store.state.registration.form2.jiuzhenyiyuan,
                        remarks: '',
                    }
                )
                this.sorted()
            },
            filter(value, time, label, valuee, auto) {
                if (!time) {
                    this.$message({
                        message: '请填写时间!',
                        type: 'error'
                    })
                    return
                }
                var ttime = this.$store.state.registration.form2.jiuzhenriqi
                if (ttime && ttime.indexOf(' ') > -1) {
                    if (time < ttime.split(" ")[0]) {
                        this.$message({
                            message: value + '时间大于初发时间',
                            type: 'warning'
                        })
                        return
                    }
                }

                var that = this
                var flag = 0
                var vflag = ''
                var siwang = 0
                this.form6.timeline.forEach(function (item) {
                    var temptime = item.time.split("#")[0]
                    if (item.falg != 1) {
                        if (item.label == '死亡' || item.label == '失访' || item.label == '放弃') {
                            vflag = item.label
                        }
                        if (item.label == '死亡') {
                            siwang = 1
                        }
                    }
                    var tm = time
                    try {
                        tm = tm.replace(/[^\d]/g, '').slice(0, 8)
                        temptime = temptime.replace(/[^\d]/g, '').slice(0, 8)
                    } catch (e) {
                        console.log(e)
                    }

                    if (item.label === value && tm === temptime) {
                        if (item.falg != 1) {
                            flag = 1
                        }
                    }
                });
                if (flag == 0) {
                    that.addRow(value, time, label, valuee)
                } else {
                    if (auto != 1) {
                        this.$message({
                            message: value + '：同时间已经添加过！',
                            type: 'error'
                        })
                    }
                }
                if (vflag) {
                    this.$store.state.registration.form7.shengcunzhuangtai = vflag
                } else {
                    this.$store.state.registration.form7.shengcunzhuangtai = "存活"
                }
                if (siwang == 1) {
                    this.$store.state.registration.form7.shengcunzhuangtai = "死亡"
                }
            },
            sorted() {
                var temp = {}
                var data = []
                var flag = 0
                var keyList = []
                for (var m = 0; m < this.form6.timeline.length; m++) {
                    var timeline = this.form6.timeline[m].time || ''
                    if (timeline) {
                        timeline = timeline.split(' ')[0]
                    }
                    var key = (timeline + m).replace(/[^\d]/g, '')
                    temp[key] = this.form6.timeline[m]
                    keyList.push(key)
                }
                var resArr = keyList.sort();
                var type = this.$store.state.registration.form2.zhenduanfenxing
                if (type.length == 1) {
                    type = type[0]
                } else {
                    type = type[1]
                }
                var deleteList = []
                for (var i = 0; i < resArr.length; i++) {
                    if (temp[resArr[i]].label == "初发") {
                        flag = 1
                        temp[resArr[i]].time = this.$store.state.registration.form2.jiuzhenriqi
                        temp[resArr[i]].jiuzhennianling = this.$store.state.registration.form2.jiuzhennianling
                        temp[resArr[i]].type = type
                    }
                    if (temp[resArr[i]].label == "治疗" || temp[resArr[i]].label == "初治") {
                        temp[resArr[i]].type = type
                    }
                    if ((temp[resArr[i]].falg == 1 || temp[resArr[i]].falg == "1") && this.is_admin != 'true') {
                        deleteList.push(temp[resArr[i]])
                    } else {
                        data.push(temp[resArr[i]])
                    }
                }
                this.form6.imeline = []
                if (flag == 0) {
                    this.getChufa()
                    data.unshift(this.form6.timeline[0])
                }
                if (deleteList.length) {
                    data.concat(deleteList)
                }
                this.form6.timeline = data
            },
            aoutadd() {
                //放弃
                this.$on('childMethod', (cab) => {
                    this.auto = true
                    if (this.form6.fangqi_shijian) {
                        this.filter('放弃', this.form6.fangqi_shijian, '', '', 1)
                    }
                    if (this.form6.auto_sct_shijian) {
                        this.filter('移植-Auto-SCT', this.form6.auto_sct_shijian, '', '', 1)
                    }
                    if (this.form6.allo_sct_shijian) {
                        this.filter('移植-Allo-SCT', this.form6.allo_sct_shijian, '类型', this.form6.allo_sct_leixing, 1)
                    }
                    if (this.form6.huode_cr_shijian) {
                        this.filter('缓解', this.form6.huode_cr_shijian, 'MRD', this.form6.allo_sct_mrd, 1)
                    }
                    if (this.form6.huode_nr_shijian) {
                        this.filter('未缓解', this.form6.huode_nr_shijian, '', '', 1)
                    }
                    if (this.form6.shoucifufashijian) {
                        this.filter('复发', this.form6.shoucifufashijian, this.form6.zhenduanfenxing, '', 1)
                    }
                    if (this.form6.shifou_siwang) {
                        this.filter('死亡', this.form6.shifou_siwang, '死亡原因', this.form6.siwangyuanyin, 1)
                    }
                    if (this.form6.shifang_shijian) {
                        this.filter('失访', this.form6.shifang_shijian, '', '', 1)
                    }
                    if (this.form6.suifang_shijian) {
                        this.filter('随访', this.form6.suifang_shijian, '备注', this.form6.suifang_beiju, 1)
                    }
                    var falg = 0
                    for (var key in this.form6.zhiliaofangan) {
                        if (this.form6.zhiliaofangan[key]) {
                            falg = 1
                        }
                    }
                    if (falg == 1) {
                        if (!this.form6.fangan_shijian) {
                            if (cab) {
                                cab(0)
                            }
                        } else {
                            this.filter('治疗', this.form6.fangan_shijian, '', '', 1)
                            if (cab) {
                                cab(1)
                            }
                        }
                    } else {
                        if (cab) {
                            cab(1)
                        }
                    }
                })
            },
            getZhiliaaoData() {
                this.form6.timeline = this.$store.state.registration.form6.timeline
                if (this.form6.timeline.length) {
                    this.sorted()
                } else {
                    this.getChufa()
                }
                this.active = 'kms1'
            },
            getChufa() {
                var that = this
                var time = that.$store.state.registration.form2.jiuzhenriqi
                var type = that.$store.state.registration.form2.zhenduanfenxing
                if (type.length == 1) {
                    type = type[0]
                } else {
                    type = type[1]
                }
                if (time) {
                    time = time.split(' ')[0]
                }
                if (type) {
                    this.num = 1
                    this.form6.timeline = [
                        {
                            type: type,
                            other: '',
                            time: time,
                            falg: 0,
                            jiuzhennianling: that.$store.state.registration.form2.jiuzhennianling,
                            programme: '',
                            valueq: '',
                            label: '初发',
                            labelq: '',
                            hospital: that.$store.state.registration.form2.jiuzhenyiyuan,
                            remarks: '',
                        }
                    ]
                }
            }
        },
        mounted() {
            this.aoutadd()
        }
    };
</script>

<style scoped>
    .sui /deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 10px;
    }
    ::v-deep .md-stepper-number{
        background-color: #448aff  !important;
    }
    .container /deep/ .md-button-content {
        color: red !important;
    }
    .tag-2 /deep/ .md-button-content{
        /*text-decoration: line-through;*/
        /*text-decoration-color: black;*/
        color: #c0c4cc !important;
    }
    .tag-3 /deep/ .md-button-content{
        color: #67c23a !important;
    }

     /deep/ .md-button-content {
        color: black !important;
    }

    ::v-deep .tag  .md-stepper-header{
        /*background-color: #67c23a  !important;*/
        /*opacity: 0.5;*/
        border: 1.5px solid #67c23a ;
    }
    ::v-deep .tag .md-stepper-number{
        background-color: #67c23a   !important;
    }
    ::v-deep .tag-2 .md-stepper-number{
        background-color: #c0c4cc  !important;

        /*text-decoration: line-through;*/
        /*text-decoration-color: black;*/
    }
    ::v-deep .tag-3 .md-stepper-number{
        background-color: #67c23a   !important;
    }
    /*::v-deep .tag-3   .md-stepper-header{*/
    /*    background-color:  rgb(229 229 229) !important;*/
    /*}*/

    /*::v-deep .tag-2   .md-stepper-header{*/
    /*    background-color:  rgb(229 229 229) !important;*/
    /*}*/

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 125px;
    }

    .el-row {
        margin: 20px 0;
    }

    .el-button--mini, .el-button--mini.is-round {
        padding: 4px 15px;
    }

    /deep/ .el-col-2 {
        line-height: 32px;
    }

    .el-col-3 {
        font-size: 14px;
    }

    .aml /deep/ .el-input-group__append,
    .aml /deep/ .el-input-group__prepend {
        padding: 0 5px;
    }

    .aml /deep/ .el-date-editor.el-input,
    .aml /deep/ .el-date-editor.el-input__inner {
        /* width: 220px; */
    }

    .aml /deep/ .el-select .el-input {
    }

    .aml /deep/ .input-with-select .el-input-group__prepend {
        background-color: #fff;
        padding: 0 20px;
    }

    .heard {
        margin: 5px;
        border: 1px solid #eee;
        padding: 0 10px;
    }

    .heard-label {
        font-size: 15px;
        margin-bottom: 10px
    }

    .siwang /deep/ .el-checkbox__input {
        margin-top: 4px;
    }

    .all /deep/ .md-stepper-content {
        height: auto;
        padding-bottom: 40px;
        opacity: 1;
        display: inherit !important;
        transform: translate3D(0, 0, 0);
    }

    .is_acivt {
        background-color: aliceblue;
        padding-top: 18px;
    }

    .zhiliao-event {
        border-bottom: 1px solid aliceblue;
    }
    ::v-deep .el-collapse-item__header {
        color: #fff;
        background-color: #67c23a;
        padding: 0px 10px;
        font-size: 16px;
    }
</style>
